import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { PlaceTable } from "../backend/cloud/PlaceTable";
import { PlaceReportTable } from "../backend/cloud/PlaceReportTable";
import { UserTable } from "../backend/cloud/UserTable";
import { PlaceMediaTable } from "../backend/cloud/PlaceMediaTable";
import { JournalTable } from "../backend/cloud/JournalTable";

@customElement("ds-database-operations")
export class DatabaseOperations extends BaseElement {
    static override styles = [
        Style,
        css`
            sl-button {
                width: 100%;
            }
        `,
    ];

    private _placesTable = this._kernel.dataStore.getSource<PlaceTable>("places");
    private _userTable = this._kernel.dataStore.getSource<UserTable>("users");

    override render() {
        return html`
            <div class="flex-column">
                <sl-button size="medium" @click=${() => this._raiseEvent("ds-bulk-import")}
                    >Bulk import</sl-button
                >
                <sl-button
                    size="medium"
                    @click=${async () => await this._placesTable.setElevationOnAll()}
                    >Set elevation on all places</sl-button
                >
                <sl-button
                    size="medium"
                    @click=${async () => await this._placesTable.setAddressAll(true)}
                    >Set address on all places</sl-button
                >
                <sl-button
                    size="medium"
                    @click=${async () => await this._userTable.removeDuplicates()}
                    >Remove duplicate user infos</sl-button
                >
                <sl-button
                    size="medium"
                    @click=${async () =>
                        await this._kernel.dataStore
                            .getSource<PlaceReportTable>("place-report")
                            .fixItemsWithNoOwner()}
                    >Fix ownerless place reports</sl-button
                >
                <sl-button
                    size="medium"
                    @click=${async () =>
                        await this._kernel.dataStore
                            .getSource<PlaceMediaTable>("place-media")
                            .generateThumbnails()}
                    >Create missing thumbnails</sl-button
                >
                <sl-button
                    size="medium"
                    @click=${async () =>
                        await this._kernel.dataStore
                            .getSource<JournalTable>("journals")
                            .fixupJournalCollections()}
                    >Fix journal collections and modifications</sl-button
                >
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-database-operations": DatabaseOperations;
    }
}
